import { render, staticRenderFns } from "./index.vue?vue&type=template&id=316cb230"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316cb230')) {
      api.createRecord('316cb230', component.options)
    } else {
      api.reload('316cb230', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=316cb230", function () {
      api.rerender('316cb230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/journalManage/index.vue"
export default component.exports